import PropTypes from "prop-types";
import React from "react";
import {shallowEqual, useSelector} from "react-redux";
import {ContextualMenu, DefaultButton, Dialog, DialogFooter, DialogType} from "@fluentui/react";
import * as uiServices from "../services/ui/ui-services";

const ErrorDialog = prps => {

  const selectors = useSelector(
    state => ({
      lastError: state.error.lastError
    }),
    {equalityFn: shallowEqual}
  );
  const props = {...prps, ...selectors};

  const {semanticColors} = uiServices.useTheme();

  const [showDialog, setShowDialog] = React.useState(false);

  React.useLayoutEffect(() => {
    if (props.lastError)
      setShowDialog(true);
  }, [props.lastError]);

  const dialogContentProps = {
    type: DialogType.normal,
    title: "Error",
    subText: <span>{props.lastError?.message}</span>
  };
  const modalProps = {
    isBlocking: true,
    dragOptions: {
      moveMenuItemText: "Move",
      closeMenuItemText: "Close",
      menu: ContextualMenu,
      keepInBounds: true
    },
    styles: {
      main: {
        borderTopWidth: 5,
        borderTopStyle: "solid",
        borderColor: semanticColors.severeWarningIcon
      }
    }
  };
  
  const dismissDialog = () =>
    setShowDialog(false);
  
  return (
    <Dialog
      dialogContentProps={dialogContentProps}
      modalProps={modalProps}
      hidden={!showDialog}
      onDismiss={dismissDialog}>
      <DialogFooter>
        <DefaultButton
          text="Sluiten"
          onClick={dismissDialog}
        />
      </DialogFooter>
    </Dialog>
  );
};

ErrorDialog.propTypes = {
  lastError: PropTypes.object
};

export default ErrorDialog;